import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const lioneldConfig: TSPConfig = {
  key: 'lioneld',
  name: 'Lion ELD',
  imageName: 'LionELD',
  category: TSPCategory.CUSTOM,
  helpText: 'Please input the Company ID from your Lion ELD profile.',
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'Enter Company ID',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default lioneldConfig;
